export enum PageState {
  Loading = 'Loading',
  LoadingSuccess = 'LoadingSuccess',
  LoadingMore = 'LoadingMore',
  LoadingMoreError = 'LoadingMoreError',
}
